<template>
  <div class="dic-body">
    <h1 class="dictionary-title">{{ $t("dictionary.dictionary.dict") }}</h1>
    <div :style="safeZones" class="dic-container">
      <div>
        <Search @selectedWord="selectedWord" @addWord="addWord"></Search>
        <Box
          :language="language"
          v-if="word"
          :word="word"
          @search="searchWord"
          @saveWord="saveWord"
          :savedWords="savedWords"
          :hebSen="hebSen"
          :arabSen="arabSen"
          :sentenceId="sentenceId"
          :sentences="sentences"
        >
        </Box>
        <div v-if="msg" class="msg">{{ msg }}</div>
      </div>

      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ $t("dictionary.dictionary.title") }}
          </v-card-title>

          <v-card-text>
            <textarea
              id="addword"
              name="addword"
              :placeholder="placeholder"
              class="textBox"
              v-model="wordSuggestion"
            ></textarea>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="sendBtn"
              flat
              @click="sendWordRequest"
            >
              {{ $t("dictionary.dictionary.send") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import "./dictionary.scss";
import ChapterHeader from "../chapter/chapter-header";
import Search from "./search.vue";
import Box from "./box.vue";
import { userService } from "../../services/userService";
import { wordService } from '../../services/wordService';

export default {
  props: [],
  data() {
    return {
      wordSuggestion: "",
      dialog: false,
      msg: "",
      hebSen: null,
      arabSen: null,
      sentenceId: null,
      sentences: [],
      svg: require("../../assets/svg/mandala.svg"),
      placeholder: this.$t("dictionary.dictionary.suggest")
    };
  },
  created() {},
  computed: {
    word() {
      return this.$store.getters.currWord;
    },
    language() {
      return this.$store.getters.language;
    },
    user() {
      return this.$store.getters.user;
    },
    getRank() {
      if (this.user) {
        return this.user.user_rank || 0;
      } else {
        return 0;
      }
    },
    safeZones() {
      return {
        "--safe":
          this.$store.getters.safeBottom + this.$store.getters.safeTop + "px"
      };
    },
    savedWords() {
      if (this.user) {
        return this.user.saved_words.map(word => word.external_id);
      } else {
        return [];
      }
    }
  },
  watch: {
    word() {
      console.log("WORD", this.word);
      if (this.word) this.getMatchWords(this.word.Eng);
      else {
        this.hebSen = null;
        this.arabSen = null;
        this.sentenceId = null;
        this.sentences = [];
      }
    }
  },
  methods: {
    setLanguage() {
      this.$store.commit({ type: "setLanguage", language: this.language });
      this.$store.commit({ type: "setCurrWord", currWord: null });
    },
    selectedWord(currWord) {
      this.$store.commit({ type: "setCurrWord", currWord });
      this.msg = "";
    },
    addWord() {
      this.dialog = true;
    },
    async sendWordRequest() {
      if (this.wordSuggestion)
        await userService.addWordSuggestion(this.wordSuggestion);
      this.wordSuggestion = "";
      this.dialog = false;
    },
    searchWord(currWord) {
      if (!currWord) {
        this.notFound = true;
        setTimeout(() => {
          this.notFound = false;
        }, 1500);
        return;
      }
      this.notFound = false;
      this.$store.commit({ type: "setCurrWord", currWord });
    },
    async saveWord({ isSaved, word }) {
      if (!this.user) {
        // this.msg = "עליך להתחבר על מנת לשמור מילים";
        this.msg = this.$t("dictionary.dictionary.msg1");
        return;
      }
      // if (this.user.premium && this.user.premium.active) {
      // } else if (this.user.savedWords.length > 5 && isSaved) {
      //   this.msg =
      //     "אתה ראשי לשמור עד  5 מילים, בשביל לשמור ללא הגבלה, אנא עבור לעמוד תשלום";
      //   return;
      // }
      // this.$store.dispatch("updateSavedWordsUser", word);
      if (isSaved) {
        (await userService.saveWord(word.id))
          ? //   ? (this.msg = `המילה ${word.heb}  נשמרה בהצלחה`)
            (this.msg = this.$t("dictionary.dictionary.msg2") + `${word.heb}`)
          : //   : (this.msg = `אירעה שגיאה בשמירת המילה`);
            (this.msg = this.$t("dictionary.dictionary.msg3"));
      } else {
        (await userService.unsaveWord(word.id))
          ? //   ? (this.msg = `המילה ${word.heb}  הוסרה בהצלחה`)
            (this.msg = this.$t("dictionary.dictionary.msg4") + `${word.heb}`)
          : //   : (this.msg = `אירעה שגיאה במחיקת המילה`);
            (this.msg = this.$t("dictionary.dictionary.msg5"));
      }
    },
    navigate(path) {
      this.$router.push(`/${path}`);
    },

    async getMatchWords(word) {
      console.log("THE WORD IS", word);
      let sword = word;
      if (word.substring(0, 3) == "to ") {
        if (word.substr(3)) {
          console.log(word.substr(3));
          sword = word.substr(3);
        }
      }
      const response = await wordService.getSentences(sword)
      const filtered_results = response.filter(
        res =>
          res.order !== -1 &&
          res.article !== "" &&
          res.words.includes(sword)
      );
      if (!filtered_results.length) return;
      console.log("Found it few times:", filtered_results);
      const res_check = [];
      const resd = [];
      filtered_results.forEach((res, idx) => {
        if (!res_check.includes(res.sentence)) {
          // if (this.sentences.length === 3) {
          //   return;
          // }
          res_check.push(res.sentence);
          resd.push(res);
          const articleId = res.article;
          const sentenceNum = res.sentence;
          const articles = this.$store.getters.articles
            .filter(
              res => res.article == articleId && res.sentence == sentenceNum
            )
            .sort((a, b) => {
              return a.order > b.order ? 1 : -1;
            });
          this.sentenceId = "en_" + sentenceNum + "_full";
          this.arabSen = articles
            .filter(res => res.order > 0)
            .sort((a, b) => {
              return a.order > b.order ? 1 : -1;
            })
            .map(word => {
              return word.words;
            })
            .join(" ");
          console.log(this.arabSen);
          this.hebSen = articles
            .filter(res => res.order === 0)
            .map(word => {
              return word.words;
            })
            .join(" ");
          this.sentences.push({
            heb: this.hebSen,
            eng: this.arabSen,
            id: this.sentenceId
          });
        }
      });
    },
  },
  components: {
    Search,
    ChapterHeader,
    Box
  }
};
</script>
<style scoped>
.textBox {
  /* border-style: dashed; */
  font-size: 20px;
  width: 100%;
}

.dictionary-title {
  display: flex;
  font-size: 22px;
  text-align: center;
  font-weight: 400;
  align-items: center;
  justify-content: center;
  background-color: #e7e8fd;
  padding: 5px 2px;
  height: 60px;
}

.sendBtn {
  font-size: 18px;
  background-color: #555fff;
  padding: 4px;
  color: white;
  font-weight: 400;
}

/* .dic-container {
  height: calc(100vh - 122px - var(--safe));
} */
</style>


// WEBPACK FOOTER //
// Dictionary.vue?c34b913c